import { useState } from "react";
import { createFileRoute, Link } from "@tanstack/react-router";
import { useMutation } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Button } from "@/ui/Button";
import { Field, Input } from "@/ui/Field";
import { AuthCard, FormError, FormNotice } from "@/features/auth/AuthCard";

export const Route = createFileRoute("/_public/forgot-password")({
  component: ForgotPasswordScreen,
});

function ForgotPasswordScreen() {
  const [email, setEmail] = useState("");

  const request = useMutation({
    mutationFn: () => api.post<{ message: string }>("/auth/password-reset", { email }),
  });

  return (
    <AuthCard
      title="Reset your password"
      subtitle="We will email you a link to choose a new one."
      footer={
        <Link to="/sign-in" className="font-medium text-[var(--primary)] hover:underline">
          Back to sign in
        </Link>
      }
    >
      {request.isSuccess ? (
        <FormNotice title="Check your email.">
          If that address has an account, a reset link is on its way. It expires in one hour and
          can be used once.
        </FormNotice>
      ) : (
        <form
          className="flex flex-col gap-4"
          onSubmit={(event) => {
            event.preventDefault();
            request.mutate();
          }}
        >
          <Field label="Email address" required>
            {({ id, describedBy }) => (
              <Input
                id={id}
                type="email"
                autoComplete="username"
                autoFocus
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                aria-describedby={describedBy}
              />
            )}
          </Field>

          {request.error ? <FormError error={request.error} /> : null}

          <Button type="submit" tone="primary" wide busy={request.isPending}>
            Send reset link
          </Button>
        </form>
      )}
    </AuthCard>
  );
}
